import axios from 'axios';

const Axios = axios.create({
    baseURL : 'http://47.94.145.146:8082/',
    headers : {
        'Content-Type' : 'multipart/form-data'
    }
})

const erphttp = {};
erphttp.install = function (Vue, options) {
    Vue.prototype.$erphttp = Axios;
}

export default erphttp;



// WEBPACK FOOTER //
// ./src/plugins/erphttp.js